import React, { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
    FiSearch,
    FiX,
    FiLoader
} from "react-icons/fi";
import dayjs from "dayjs";
import attendanceService from "../services/attendanceService";
import useDebounce from "../hooks/useDebounce";
import "../styles/attendance-search.css";

export default function AttendanceSearch({

    onSelect

}) {

    const [keyword, setKeyword] = useState("");

    const [results, setResults] = useState([]);

    const [loading, setLoading] = useState(false);

    const [showDropdown, setShowDropdown] = useState(false);

    const [selectedIndex, setSelectedIndex] = useState(-1);

    const debouncedKeyword = useDebounce(keyword, 400);

    const wrapperRef = useRef(null);

    useEffect(() => {

        if (!debouncedKeyword.trim()) {

            setResults([]);

            return;

        }

        searchSessions();

    }, [debouncedKeyword]);

    async function searchSessions() {

        try {

            setLoading(true);

            const response = await attendanceService.search(

                debouncedKeyword

            );

            setResults(response.sessions || []);

            setShowDropdown(true);

        }

        catch (error) {

            console.error(error);

        }

        finally {

            setLoading(false);

        }

    }

    function clearSearch() {

        setKeyword("");

        setResults([]);

        setSelectedIndex(-1);

        setShowDropdown(false);

    }

    function selectItem(item) {

        setKeyword(item.title);

        setShowDropdown(false);

        onSelect(item);

    }

    function handleKeyDown(e) {

        if (!results.length) return;

        if (e.key === "ArrowDown") {

            e.preventDefault();

            setSelectedIndex((prev) =>

                prev < results.length - 1

                    ? prev + 1

                    : prev

            );

        }

        if (e.key === "ArrowUp") {

            e.preventDefault();

            setSelectedIndex((prev) =>

                prev > 0

                    ? prev - 1

                    : 0

            );

        }

        if (

            e.key === "Enter" &&

            selectedIndex >= 0

        ) {

            selectItem(

                results[selectedIndex]

            );

        }

        if (e.key === "Escape") {

            setShowDropdown(false);

        }

    }

    useEffect(() => {

        function handleClick(e) {

            if (

                wrapperRef.current &&

                !wrapperRef.current.contains(e.target)

            ) {

                setShowDropdown(false);

            }

        }

        window.addEventListener(

            "click",

            handleClick

        );

        return () =>

            window.removeEventListener(

                "click",

                handleClick

            );

    }, []);

    function badge(status) {

        switch (status) {

            case "Present":

                return "green";

            case "Absent":

                return "red";

            case "Late":

                return "blue";

            default:

                return "purple";

        }

    }

    return (

        <div

            className="attendance-search"

            ref={wrapperRef}

        >

            <div className="attendance-search-box">

                <FiSearch className="search-icon"/>

                <input

                    type="text"

                    placeholder="Search attendance session..."

                    value={keyword}

                    onChange={(e)=>

                        setKeyword(

                            e.target.value

                        )

                    }

                    onFocus={()=>

                        setShowDropdown(true)

                    }

                    onKeyDown={handleKeyDown}

                />

                {

                    loading &&

                    <FiLoader

                        className="loading-icon spin"

                    />

                }

                {

                    keyword &&

                    <button

                        className="clear-btn"

                        onClick={clearSearch}

                    >

                        <FiX/>

                    </button>

                }

            </div>

            <AnimatePresence>

            {

                showDropdown &&

                results.length > 0 &&

                <motion.div

                    className="attendance-search-results"

                    initial={{

                        opacity:0,

                        y:-15

                    }}

                    animate={{

                        opacity:1,

                        y:0

                    }}

                    exit={{

                        opacity:0,

                        y:-10

                    }}

                >

                    {

                        results.map(

                            (

                                item,

                                index

                            )=>(

                            <div

                                key={item.id}

                                className={`attendance-search-item ${
                                    selectedIndex===index
                                    ? "active"
                                    : ""
                                }`}

                                onClick={()=>selectItem(item)}

                            >

                                <div>

                                    <h4>

                                        {item.title}

                                    </h4>

                                    <span>

                                        {

                                            dayjs(

                                                item.attendance_date

                                            ).format(

                                                "DD MMM YYYY"

                                            )

                                        }

                                    </span>

                                </div>

                                <span

                                    className={`badge ${badge(item.status)}`}

                                >

                                    {item.status}

                                </span>

                            </div>

                        ))

                    }

                </motion.div>

            }

            </AnimatePresence>

        </div>

    );

}